import { Radio as RadioA } from 'antd';
import cn from 'classnames';
import type { ComponentProps } from 'react';

import Radio from '../Radio';
import styles from './radio-group.module.css';

type P = {
  fullWidth?: boolean;
} & Omit<ComponentProps<typeof RadioA.Group>, 'buttonStyle'>;

const RadioGroup = ({ children, className, fullWidth, options, ...rest }: P) => {
  const content = options
    ? options.map((option) => {
        const radioOption =
          typeof option === 'string' || typeof option === 'number' ? { label: option, value: option } : option;

        return (
          <Radio key={String(radioOption.value)} {...radioOption}>
            {radioOption.label}
          </Radio>
        );
      })
    : children;

  return (
    <RadioA.Group
      buttonStyle="solid"
      className={cn(className, styles['radio-group'], {
        [styles['radio-group--full-width'] ?? '']: fullWidth,
      })}
      {...rest}
    >
      {content}
    </RadioA.Group>
  );
};

export default RadioGroup;
